import { skipToken as reactQuerySkipToken } from "@tanstack/react-query";
import { useCurrentWorkspaceId } from "@v2/contexts/WorkspaceDashboardContext";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { analyticsRouter } from "@v2/trpc/routes/analytics";
import { integrationRouter } from "@v2/trpc/routes/integration";

/**
 * NOTE Ben 2024-10-01: This is intended to be a stop-gap measure to allow self-onboarding from
 * the setup screen while we work on the rest of self-onboarding. It will be removed and replaced
 * in REPL-13622, REPL-13621, or REPL-13620.
 */
export function useAnalyticsOnboardingOAuthLink(forShopifyUrl?: string) {
  const workspaceId = useCurrentWorkspaceId();
  const projectId = useCurrentProjectId();

  const { data: projectShopifyUrl } =
    integrationRouter.getUrlByProjectId.useQuery(
      projectId ? { projectId } : reactQuerySkipToken,
    );

  const { data: integrationsData, isLoading: isLoadingIntegration } =
    integrationRouter.getWorkspaceShopifyIntegrationDataV2.useQuery(
      !projectId && workspaceId ? { workspaceId } : reactQuerySkipToken,
    );

  const integration = (integrationsData ?? [])[0];
  const shopifyUrl =
    forShopifyUrl ?? projectShopifyUrl ?? integration?.config?.shopifyUrl;

  const { data: oauthLink, isLoading: isLoadingOauthLink } =
    analyticsRouter.generateOAuthLink.useQuery(
      workspaceId && shopifyUrl
        ? {
            workspaceId,
            projectId,
            shopifyUrl,
          }
        : reactQuerySkipToken,
    );
  const isLoading = isLoadingIntegration || isLoadingOauthLink;
  return {
    isLoading,
    oauthLink,
  };
}
